import React, { useEffect, useState } from 'react';
import PasswordEye from '../../assets/login/password-eye.svg';
import PasswordEyeOff from '../../assets/login/password-eye-off.svg';
import { SIGNIN } from '../../constants/routes';
import './LoginInput.css';

const LoginInput = ({
  placeholder,
  Icon,
  onChange,
  name,
  value,
  error,
  type = 'text',
  isPassword,
  className = '',
}) => {
  const [focus, setFocus] = useState(false);
  const [showPassword, setShowPassword] = useState(true);

  useEffect(() => {
    if (location.pathname === SIGNIN) {
      setShowPassword(false)
    } else {
      setShowPassword(true);
    };
  }, [location.pathname]);

  return (
    <div className={`${className} my-1 w-100`}>
      <div
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className={`login-input-container position-relative bg-transparent rounded-0 d-flex w-100 ${focus || value?.length ? 'login-input-focused' : 'login-input-blur'
          } ${error && 'border-danger'}`}
      >
        {Icon && (
          <Icon
            error={error}
            selected={focus || value?.length}
            className="input-login-image align-self-center ml-3"
          />
        )}
        <input
          type={showPassword ? 'text' : type}
          onChange={onChange}
          name={name}
          role={name}
          value={value}
          className="login-input outline-none  text-xs bg-transparent w-100 border-0 position-relative d-inline-block"
          autoComplete={type === "password" ? "off" : "on"}
          placeholder={placeholder}
          data-testid={`login-input-${name}-input`}
        />
        {isPassword && (
          <img
            src={!showPassword ? PasswordEyeOff : PasswordEye}
            onClick={() => {
              setShowPassword(!showPassword);
            }}
            className="input-login-image mx-2"
            alt="asd"
            role="button"
          />
        )}
      </div>
      {error && (
        <p className="danger-text  text-xs m-0 mt-1 p-0" data-testid="login-input-error-p">
          {error}
        </p>
      )}
    </div>
  );
};

export default LoginInput;
